import { X } from "lucide-react"
import { cn } from "@/lib/class-control"

interface PDFPreviewProps {
  title: string
  subtitle?: string
  pdfUrl: string | null
  onClose?: () => void
  className?: string
}

export function PDFPreview({
  title,
  subtitle,
  pdfUrl,
  onClose,
  className,
}: PDFPreviewProps) {
  return (
    <div
      className={cn(
        "bg-[#0c1427] p-7 m-7 rounded-2xl",
        "flex flex-col justify-between",
        className
      )}
    >
      {/* Header */}
      <div className="flex items-start justify-between gap-[2px]">
        <div className="flex flex-col gap-[2px] w-[647px]">
          <h2 className="font-bold text-[24px] text-white">{title}</h2>
          {subtitle && (
            <p className="font-normal text-[14px] text-[#d1d1d1]">{subtitle}</p>
          )}
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="w-[24px] h-[24px] flex items-center justify-center text-white hover:text-red-400 transition-colors"
          >
            <X className="w-[24px] h-[24px]" />
          </button>
        )}
      </div>

      {/* Large PDF Preview */}
      <div className="h-[801px] rounded-[12px] bg-gray-800 overflow-hidden">
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            className="w-full h-full"
            title={`Preview de ${title}`}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-400">
            <p className="text-[14px]">Nenhum documento carregado</p>
          </div>
        )}
      </div>
    </div>
  )
}
